import { render, staticRenderFns } from "./HistorialEncuestasGeneral.vue?vue&type=template&id=095b5775&"
import script from "./HistorialEncuestasGeneral.vue?vue&type=script&lang=js&"
export * from "./HistorialEncuestasGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports